const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var GooglePay24 = function GooglePay24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.917 13.26v4.656H19.44V6.418h3.918a3.542 3.542 0 0 1 2.536.995 3.2 3.2 0 0 1 1.06 2.427 3.186 3.186 0 0 1-1.06 2.44c-.685.654-1.53.98-2.536.98h-2.44zm0-5.427v4.014h2.477a1.953 1.953 0 0 0 1.462-.594 1.958 1.958 0 0 0 0-2.81 1.926 1.926 0 0 0-1.462-.61h-2.477zm9.44 1.96c1.093 0 1.954.291 2.586.875.632.583.948 1.383.947 2.4v4.848h-1.413v-1.092h-.064c-.612.9-1.425 1.349-2.44 1.349-.867 0-1.592-.257-2.176-.77a2.46 2.46 0 0 1-.875-1.927c0-.814.308-1.462.923-1.943.615-.48 1.437-.721 2.464-.722.877 0 1.6.16 2.167.481v-.337a1.681 1.681 0 0 0-.61-1.308c-.39-.352-.9-.544-1.426-.538-.825 0-1.478.348-1.958 1.044l-1.301-.82c.715-1.027 1.774-1.54 3.177-1.54zm-1.91 5.715a1.18 1.18 0 0 0 .49.963c.326.257.732.393 1.147.386a2.355 2.355 0 0 0 1.662-.69c.49-.461.734-1.001.734-1.622-.46-.367-1.103-.55-1.927-.55-.6 0-1.1.145-1.5.434-.405.293-.606.65-.606 1.079zm8.62 5.876L42 10.049h-1.608l-2.28 5.652h-.032l-2.344-5.652H34.13l3.243 7.369-1.83 3.966h1.525z",
      fill: "#5F6368",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M14.948 12.257c0-.45-.037-.9-.113-1.344h-6.23v2.544h3.568a3.058 3.058 0 0 1-1.32 2.008v1.651h2.13c1.247-1.15 1.965-2.85 1.965-4.86z",
      fill: "#4285F4",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.605 18.712c1.783 0 3.284-.586 4.378-1.595l-2.13-1.651c-.592.402-1.355.63-2.248.63-1.723 0-3.185-1.16-3.708-2.726H2.703v1.702a6.606 6.606 0 0 0 5.902 3.64z",
      fill: "#34A853",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M4.897 13.37a3.958 3.958 0 0 1 0-2.528V9.14H2.703a6.606 6.606 0 0 0 0 5.932l2.194-1.702z",
      fill: "#FBBC04",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.605 8.115a3.586 3.586 0 0 1 2.534.991l1.886-1.885a6.347 6.347 0 0 0-4.42-1.72A6.606 6.606 0 0 0 2.703 9.14l2.194 1.702c.523-1.565 1.985-2.727 3.708-2.727z",
      fill: "#EA4335",
    })
  );
};
GooglePay24.defaultProps = {
  width: "44",
  height: "24",
  viewBox: "0 0 44 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var GooglePay32 = function GooglePay32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "#fff",
      stroke: "#CCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M15.42 12.52v2.9h-.92V8.26h2.43c.62 0 1.15.2 1.58.62.44.4.66.91.66 1.5 0 .61-.22 1.11-.66 1.52-.43.4-.96.6-1.58.6h-1.51v.01Zm0-3.37v2.5h1.53c.37 0 .67-.13.91-.38a1.2 1.2 0 0 0 0-1.74 1.19 1.19 0 0 0-.9-.37h-1.54Zm6.15 1.21c.67 0 1.21.19 1.6.55.4.36.59.86.59 1.5v3h-.88v-.68h-.03c-.38.56-.89.84-1.52.84-.54 0-.99-.16-1.35-.48a1.53 1.53 0 0 1-.55-1.2c0-.5.2-.9.58-1.2.38-.3.9-.45 1.53-.45.54 0 1 .1 1.34.3v-.2c0-.33-.12-.6-.38-.82a1.3 1.3 0 0 0-.89-.33c-.5 0-.91.21-1.21.65l-.8-.51c.44-.65 1.1-.97 1.97-.97Zm-1.19 3.55c0 .24.1.44.3.6.2.16.45.24.72.24.39 0 .73-.15 1.03-.43.3-.29.45-.62.45-1.01a1.9 1.9 0 0 0-1.19-.34c-.37 0-.68.09-.93.27-.26.18-.38.4-.38.67Zm8.37-3.39-3.06 7.04h-.95l1.14-2.46-2.02-4.58h1l1.46 3.51h.02l1.41-3.5h1Z",
      fill: "#3C4043",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M11.77 11.94c0-.3-.03-.59-.08-.86H7.84v1.57h2.22a1.9 1.9 0 0 1-.82 1.27v1.03h1.32a4 4 0 0 0 1.2-3.01Z",
      fill: "#4285F4",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M9.24 13.93c-.37.24-.84.39-1.4.39a2.45 2.45 0 0 1-2.3-1.7H4.2v1.06a4.1 4.1 0 0 0 3.66 2.26 3.9 3.9 0 0 0 2.7-1l-1.31-1.01Z",
      fill: "#34A853",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M5.42 11.84c0-.27.04-.53.13-.78v-1.05H4.19a4.07 4.07 0 0 0 0 3.67l1.36-1.05a2.47 2.47 0 0 1-.13-.79Z",
      fill: "#FABB05",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M7.85 9.37c.6 0 1.14.2 1.57.61l1.17-1.16A4.1 4.1 0 0 0 4.19 10l1.36 1.05a2.45 2.45 0 0 1 2.3-1.69Z",
      fill: "#E94235",
    })
  );
};
GooglePay32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: GooglePay24,
  32: GooglePay32,
};
export function GooglePay(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'GooglePay' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
